import React, { ReactNode } from 'react';
import { OrderProvider } from './OrderProvider';
import { PrinterProvider } from './PrinterProviderV2';
import CartProvider from './CartProvider';
import DrawerProvider from '~/providers/DrawerProvider';

// providers that depend on restaurantid
const Providers = ({ children }: { children?: ReactNode }) => {
  return (
    <PrinterProvider>
      <OrderProvider>
        <CartProvider>
          <DrawerProvider>{children}</DrawerProvider>
        </CartProvider>
      </OrderProvider>
    </PrinterProvider>
  );
};

export default Providers;
